import { useQuery } from '@tanstack/react-query';

import { getTicketRiskHistory } from '~/services/SupportService';

import { ticketRiskQueryKeys } from './useTicketRiskReport';

interface UseGetTicketRiskHistoryParams {
  ticketId: string | null;
  /** Runs to return, newest first, before the trend line is reversed. svc-support clamps this to 1-100. */
  limit?: number;
  enabled?: boolean;
}

/**
 * Score history for one ticket — one point per scoring run. The batch job only writes new
 * points when it runs, so this is stable data; it is fetched lazily because only the ticket
 * detail dialog needs it.
 */
export function useGetTicketRiskHistory({ ticketId, limit, enabled = true }: UseGetTicketRiskHistoryParams) {
  return useQuery({
    queryKey: ticketRiskQueryKeys.history(ticketId, limit),
    queryFn: async ({ signal }) => getTicketRiskHistory(ticketId, { limit }, { signal }),
    enabled: enabled && !!ticketId,
    refetchOnWindowFocus: false,
    // A 404 means the ticket has never been scored — retrying will not conjure a history.
    retry: (failureCount, error) => ((error as { status?: number }).status === 404 ? false : failureCount < 2),
  });
}
